import Navbar from "../../components/home/New/Navbar";
import B2BHero from "../../components/business/Hero";
import Brand from "../../components/referral/New/Brands";
import FaqSection from "../../components/home/New/FaqSection";
import BusinessProcess from "../../components/business/Process";
import BusinessStages from "../../components/business/Stages";
import BusinessPartnership from "../../components/business/Partnership";
import BusinessContactForm from "../../components/business/B2BAssessmentForm";
import BusinessTestimonials from "../../components/business/Testimonials";
import PartnerCTA from "../../components/partnerships/Cta";
import Footer from "../../components/home/New/Footer";
import B2Bsteps from "../../components/business/B2Bsteps";
import InfluencerSection from "../../components/home/New/InfluencerSection";
import MasterTools from "../../components/home/New/MasterTools";
import SwipeCards from "../../components/home/New/swipecards";
import Mentors from "../../components/home/New/Mentors";

const B2Bpage = () => {
  return (
    <div className="relative">
      <Navbar />
      <B2BHero />
      <Brand />
      <BusinessPartnership />
      <BusinessStages />
      <div className="hidden md:block">
        <MasterTools />
      </div>
      <div className="block md:hidden">
        <SwipeCards />
      </div>
      <B2Bsteps />
      <Mentors />
      <InfluencerSection />
      <BusinessContactForm />
      <BusinessProcess />
      <BusinessTestimonials />
      <FaqSection slug="business" />
      <PartnerCTA
        heading="Ready to build an AI-native team?"
        description="Tell us about your team and we'll scope a program built around how you actually work."
        ctaLabel="Request a Callback"
        email="corporate@outskill.com"
        onCtaClick={() => {
          document
            .getElementById("business-contact")
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
        }}
      />
      <Footer />
    </div>
  );
};

export default B2Bpage;
